module.exports = __webpack_public_path__ + "static/media/om.6792d205.svg";